var React = require('react');

function Zap (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"none","strokeWidth":"1","fill":"#333","d":"M20.444 9.271c-.085-.167-.256-.271-.444-.271h-7.377l1.865-8.392c.051-.232-.067-.468-.285-.565-.216-.097-.472-.027-.61.166l-10 14c-.109.152-.124.353-.038.519.086.168.257.272.445.272h7.377l-1.865 8.392c-.051.232.067.468.285.565l.203.043c.157 0 .311-.075.407-.209l10-14c.109-.153.123-.353.037-.52zm-9.423 11.939l1.467-6.602c.033-.148-.003-.303-.098-.421s-.238-.187-.39-.187h-7.028l8.007-11.21-1.467 6.602c-.033.148.003.303.098.421s.238.187.39.187h7.028l-8.007 11.21z"}));
}

Zap.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Zap;

Zap.default = Zap;
